import React, { useEffect } from 'react';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

// Fix for default marker icon in React-Leaflet
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

// Custom red marker icon
const redIcon = new L.Icon({
  iconUrl: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-red.png',
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41]
});

const LocationMap = () => {
  // Redspire Civil Engineering address coordinates
  // 218 Brookside Industrial Park, Stamford, CT 06902
  const position = [41.0534, -73.5387]; // Stamford, CT coordinates
  
  useEffect(() => {
    // Fix for map container sizing issues
    window.dispatchEvent(new Event('resize'));
  }, []);

  return (
    <div className="w-full h-full rounded-xl overflow-hidden border border-gray-200 shadow-md">
      <MapContainer
        center={position}
        zoom={15}
        scrollWheelZoom={true}
        style={{ height: '100%', width: '100%', minHeight: '400px' }}
        className="z-0"
      >
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        <Marker position={position} icon={redIcon}>
          <Popup>
            <div className="text-center font-semibold">
              <p className="text-red-600 font-bold text-base">Redspire Civil Engineering</p>
              <p className="text-gray-700 text-sm mt-1">218 Brookside Industrial Park</p>
              <p className="text-gray-700 text-sm">Stamford, CT 06902</p>
              <p className="text-gray-700 text-sm mt-2">United States</p>
            </div>
          </Popup>
        </Marker>
      </MapContainer>
    </div>
  );
};

export default LocationMap;
